export const getAccountingDayRoutingById = (state: State) =>
  state.accountingDayRouting.byId;

export const getIsFetchingAccountingDayRouting = (state: State) =>
  state.accountingDayRouting.isFetching;
